import { call, put, select } from "redux-saga/effects";
import { DEV, handlingCodes } from "@/constants/constants";
import { actions as thirdActions } from "@/reducers/thirdParties";
import { handleSagaError } from "@/sagas/index";
import { sendMessageHeader, checkMocks } from "@/utils/commonUtils";
import {
  normalizeGetDevicesConnectedSmartWiFiResponse,
  normalizeThirdParties,
  appendRecommendedServicesDependsOnProductType,
  appendServicesToProducts,
  createServiceSlider,
  normalizeThirdServices,
  normalizeUrlActivateNetflix,
  getPhoneByHiredProductsAndProductId,
  checkItemInArray,
  checkSmartWifiDevice,
  getGamePassActivationCodeDataResponseNormalizer,
  providerCompatibilityNormalizer,
  compatibilityDisneyDataNormalizer,
  getUrlParamProvider,
} from "@/sagas/normalizers/thirdPartiesNormalizer";
import sendGaEvent from "@gcloud-npm/utils.metrics.send-ga-component-event";
import { getSmartWiFiStatus } from "@/adabyron/telcol/third-parties/get-smart-wifi-status";
import { jwtDecode } from "jwt-decode";
import { hasProviderCompatibility, hasProviderCompatibilityCapa } from "@/utils/dataHandlers/ProductDataHandler";
import { checkHasOldDisneyPark } from "@/containers/my-products/utils";
import { getToken } from "@gcloud-npm/utils.recaptcha.get-token";

import { getAllInternet } from "@/sagas/normalizers/generalManagmentNormalizer";

// import {
//   getNumberOfProducts,
//   getProducts,
//   generalFetchMyProducts,
// } from "./product";
import { MAX } from "@/constants/general-managment-constants";
import { ACTIVATED_STATE, NO_ACTIVATED_STATE, PROVIDER_ID_SKY } from "@/constants/tv";

// Gets info obtain
export const getNetflixStore = (state) =>
  state.thirdParties.netflixUrlActivation;
export const getThirdServicesFetchedFromStore = (state) =>
  state.thirdParties.listThirdServicesFetched;

const contextStore = (state) => state.main.context;
const hiredProductsStore = (state) => state.product.hiredProducts;
const hiredProductsListStore = (state) => state.product.hiredProductsList;
const urlAlejandraStore = (state) => state.thirdParties.urlAlejandra;
const smartWifiDevicesStore = (state) => state.thirdParties.smartWiFiDevices;
const disneyActivationStore = (state) => state.thirdParties.disneyActivation;

// Checks if the netflix url is already fetched.
// If no netflix is found then sends the request.
// State is updated after request is finished

export function* getCompatibilityDisneyData({ handlingCode = 0, productId }) {
  try {
    const MOCK_INFO = "getCompatibilityDisney";
    const context = yield select(contextStore);
    // yield put(thirdActions.getCompatibilityDisney(productId));
    let response = checkMocks(MOCK_INFO);
    if (response === null) {
      const data = productId;

      let getDisneyCompatibilityModule = yield call(() =>
        import("@/adabyron/telcol/tv/get-disney-compatibility")
      );
      let getDisneyCompatibility =
        getDisneyCompatibilityModule.getDisneyCompatibility;

      response = yield call(getDisneyCompatibility, {
        data,
        context,
      });
    }

    const normalizedResponse = compatibilityDisneyDataNormalizer(
      response.datos
    );

    yield put(thirdActions.successGetCompatibilityDisney(normalizedResponse));
    return {
      status: "ok",
    };
  } catch (error) {
    const reducerFailureAction =
      thirdActions.failureGetCompatibilityDisney(error);
    yield handleSagaError(
      "getCompatibilityDisney",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
    return {
      status: "ko",
      error,
    };
  }
}

export function* getDisneyActivation({ handlingCode = 0, data }) {
  try {
    let response = null;
    const disneyActivation = yield select(disneyActivationStore);

    if (!disneyActivation?.url) {
      const context = yield select(contextStore);

      const { activateDisney } = yield call(() =>
        import("@/adabyron/telcol/third-parties/activate-disney")
      );

      response = yield call(activateDisney, {
        data: { productId: data.productId },
        context,
      });

      yield put(
        thirdActions.changeStatusGetDisneyActivation({
          url: response.datos.urlActivacion,
          fetching: false,
          error: false,
        })
      );
    }
  } catch (error) {
    const reducerFailureAction = thirdActions.changeStatusGetDisneyActivation({
      url: null,
      fetching: false,
      error: true,
    });

    yield handleSagaError(
      "getDisneyActivation",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
  }
}

export function* getUrlActivateNetflix({
  handlingCode = 0,
  administrativeNumber,
}) {
  try {
    const MOCK_INFO = "getUrlActivateNetflix";
    let neflixStore = yield select(getNetflixStore);
    neflixStore = neflixStore || [];
    const keysNetflixStore = Object.keys(neflixStore);
    if (keysNetflixStore.length === 0) {
      const context = yield select(contextStore);
      let response = checkMocks(MOCK_INFO);
      if (response === null) {
        const data = { administrativeNumber };
        const action = "OTT_NETFLIX_ACTIVATION";
        const recaptchaId = process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID;
        const token = yield call(getToken, { action, recaptchaId });

        let module = yield call(() =>
          import("@/adabyron/telcol/third-parties/activate-netflix")
        );
        let promise = module.activateNetflix;
        response = yield call(promise, {
          data,
          context,
          token,
        });
      }
      const urlActivationNetflix = normalizeUrlActivateNetflix(
        response?.activationUrl
      );
      const objToReduce = {
        urlActivationNetflix,
        administrativeNumber,
      };
      yield put(thirdActions.successGetActivateNetflix(objToReduce));
    } else {
      yield put(thirdActions.changeNetflixState(false));
    }

    return {
      status: "ok",
    };
  } catch (error) {
    const reducerFailureAction = thirdActions.failureGetActivateNetflix(true);
    yield handleSagaError(
      "getUrlActivateNetflix",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
    return {
      status: "ko",
      error,
    };
  }
}

export function* getProviderCompatibility({ handlingCode = 0, payload }) {
  try {
    const { provider } = payload;
    const MOCK_INFO = "getProviderCompatibilityData";
    const context = yield select(contextStore);
    // yield put(thirdActions.getProviderCompatibilityData(provider));
    let response = checkMocks(MOCK_INFO);
    if (provider === "disney") {
      const hiredProductsListData = yield select(hiredProductsListStore);
      const hasOldDisneyPark = checkHasOldDisneyPark(hiredProductsListData);
      if (hasOldDisneyPark) {
        response = {
          status: "OK",
          timeStamp: "20240704 094349",
          version: null,
          box: "acb0201",
          datos: {
            compatibles: [
              {
                productId: "2966216229749527459863855603",
                linea: "923263241",
                compatibilidad: true,
                addOn: true,
                satelite: false,
                estado: "A",
              },
            ],
            compatiblesSatelite: [],
          },
          error: null,
          warnings: null,
        };
      }
    }
    if (response === null) {
      let getProviderCompatibilityModule = yield call(() =>
        import("@/adabyron/telcol/third-parties/get-provider-compatibility")
      );
      let getProviderCompatibility =
        getProviderCompatibilityModule.getProviderCompatibility;

      response = yield call(getProviderCompatibility, {
        data: { provider },
        context,
      });
    }

    let normalizedResponse = providerCompatibilityNormalizer(
      response.datos,
      provider
    );

    const hasCompability = hasProviderCompatibility(
      normalizedResponse,
      provider
    );
    if (!hasCompability) {
      sendGaEvent({
        gestion_paso: "disponibilidad:no",
        gestion_sistema: "tcol",
        gestion_detalle: provider,
      }, {eventType: "gestion"});
    }

    if (
      normalizedResponse &&
      Array.isArray(normalizedResponse.compatibles) &&
      normalizedResponse.compatibles.length > 0
    ) {
      if (normalizedResponse.compatibles[0].estado === "I") {
        sendGaEvent({
          gestion_paso: "disponibilidad:activable",
          gestion_sistema: "tcol",
          gestion_detalle: provider,
        }, {eventType: "gestion"});
      } else if (normalizedResponse.compatibles[0].estado === "A") {
        sendGaEvent({
          gestion_paso: "disponibilidad:ya-activado",
          gestion_sistema: "tcol",
          gestion_detalle: provider,
        }, {eventType: "gestion"});
      }
    }
    yield put(
      thirdActions.successGetProviderCompatibilityData({
        data: { fetching: false, ...normalizedResponse },
        provider,
      })
    );
    return {
      status: "ok",
    };
  } catch (error) {
    const reducerFailureAction =
      thirdActions.failureGetProviderCompatibilityData(error);
    yield handleSagaError(
      "getProviderCompatibilityData",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
    return {
      status: "ko",
      error,
    };
  }
}

export function* getNewProviderCompatibility({ handlingCode = 0, payload }) {
  try {
    const { provider } = payload;
    const MOCK_INFO = "getProviderCompatibilityData";
    const context = yield select(contextStore);
    // yield put(thirdActions.getProviderCompatibilityData(provider));
    let response = checkMocks(MOCK_INFO);
    if (response === null) {
      const ott = getUrlParamProvider(provider);
      const data = { ott };
      const action = "OTT_PROVIDER_COMPATIBILITY_GET_INFO";
      const recaptchaId = process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID;
      const token = yield call(getToken, { action, recaptchaId });

      let getProviderCompatibilityModule = yield call(() =>
        import("@/adabyron/telcol/third-parties/get-provider-compatibility-capa")
      );
      let getProviderCompatibility =
        getProviderCompatibilityModule.getProviderCompatibility;

      response = yield call(getProviderCompatibility, {
        data,
        context,
        token,
      });
    }

    let normalizedResponse = providerCompatibilityNormalizer(
      response,
      provider
    );

    const hasCompability = hasProviderCompatibilityCapa(
      normalizedResponse,
      provider
    );
    if (!hasCompability) {
      sendGaEvent({
        gestion_paso: "disponibilidad:no",
        gestion_sistema: "tcol",
        gestion_detalle: provider,
      }, {eventType: "gestion"});
    }

    yield put(
      thirdActions.successGetNewProviderCompatibilityData({
        data: { fetching: false, ...normalizedResponse },
        provider,
      })
    );
    return {
      status: "ok",
    };
  } catch (error) {
    const reducerFailureAction =
      thirdActions.failureGetProviderCompatibilityData(error);
    yield handleSagaError(
      "getProviderCompatibilityData",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
    return {
      status: "ko",
      error,
    };
  }
}

export function* getProviderStatus({ handlingCode = 0, provider }) {
  try {
    const MOCK_INFO = "getProviderStatus";
    const context = yield select(contextStore);
    let response = checkMocks(MOCK_INFO);
    if (provider === "disney") {
      const hiredProductsListData = yield select(hiredProductsListStore);
      const hasOldDisneyPark = checkHasOldDisneyPark(hiredProductsListData);
      if (hasOldDisneyPark) {
        response = {
          status: "OK",
          timeStamp: "20240704 094349",
          version: null,
          box: "acb0201",
          datos: {
            lineas: [
              {
                linea: "923263241",
                estado: "true",
                codigoPromocion: null,
                url: "",
              },
            ],
          },
          error: null,
          warnings: null,
        };
      }
    }
    if (response === null) {
      const data = { provider };
      let getProviderStatusModule = yield call(() =>
        import("@/adabyron/telcol/third-parties/get-provider-status")
      );
      let getProviderStatus = getProviderStatusModule.getProviderStatus;

      response = yield call(getProviderStatus, {
        data,
        context,
      });
    }
    if (
      response.datos &&
      Array.isArray(response.datos.lineas) &&
      response.datos.lineas.length > 0
    ) {
      if (response.datos.lineas[0].estado === "I") {
        sendGaEvent({
          gestion_paso: "disponibilidad:activable",
          gestion_sistema: "tcol",
          gestion_detalle: provider,
        }, {eventType: "gestion"});
      } else if (response.datos.lineas[0].estado === "A") {
        sendGaEvent({
          gestion_paso: "disponibilidad:ya-activado",
          gestion_sistema: "tcol",
          gestion_detalle: provider,
        }, {eventType: "gestion"});
      }

      if (provider === MAX) {
        const searchParams = new URLSearchParams(response.datos.lineas[0].url);
        const code = searchParams.get("code");
        const decodedToken = code && jwtDecode(code);
        const identCode = decodedToken?.sub;
        response.datos.lineas[0].identificationCode = identCode;
      }
    }

    yield put(
      thirdActions.successGetProviderStatusData(response.datos, provider)
    );
    return {
      status: "ok",
    };
  } catch (error) {
    const reducerFailureAction =
      thirdActions.failureGetProviderStatusData(error);
    yield handleSagaError(
      "getProviderStatus",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
    return {
      status: "ko",
      error,
    };
  }
}

export function* getNewProviderStatus({ handlingCode = 0, provider }) {
  try {
    const MOCK_INFO = "getNewProviderStatus";
    const context = yield select(contextStore);
    let response = checkMocks(MOCK_INFO);
    if (response === null) {
      const ott = getUrlParamProvider(provider);
      const data = { ott };
      const action = "OTT_PROVIDER_STATUS_ACTIVATION";
      const recaptchaId = process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID;
      const token = yield call(getToken, { action, recaptchaId });

      let getNewProviderStatusModule = yield call(() =>
        import("@/adabyron/telcol/third-parties/get-provider-status-capa")
      );
      let getNewProviderStatus = getNewProviderStatusModule.getProviderStatus;

      response = yield call(getNewProviderStatus, {
        data,
        context,
        token,
      });
    }
    if (
      response &&
      Array.isArray(response.compatibleProducts) &&
      response.compatibleProducts.length > 0
    ) {
      if (response?.compatibleProducts?.[0].state === NO_ACTIVATED_STATE) {
        sendGaEvent({
          gestion_paso: "disponibilidad:activable",
          gestion_sistema: "tcol",
          gestion_detalle: provider,
        }, {eventType: "gestion"});
      } else if (response?.compatibleProducts?.[0].state === ACTIVATED_STATE) {
        sendGaEvent({
          gestion_paso: "disponibilidad:ya-activado",
          gestion_sistema: "tcol",
          gestion_detalle: provider,
        }, {eventType: "gestion"});
      }

      if (provider === MAX || provider === PROVIDER_ID_SKY && response?.compatibleProducts?.[0]?.activationUrl) {
        const urlObj = new URL(response.compatibleProducts[0].activationUrl);
        const code = urlObj?.searchParams.get("token");
        const decodedToken = code && jwtDecode(code);
        const identCode = decodedToken?.sub;
        response.compatibleProducts[0].identificationCode = identCode;
      }
    }

    yield put(
      thirdActions.successGetProviderStatusData(response, provider)
    );
    return {
      status: "ok",
    };
  } catch (error) {
    const reducerFailureAction =
      thirdActions.failureGetProviderStatusData(error);
    yield handleSagaError(
      "getNewProviderStatus",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
    return {
      status: "ko",
      error,
    };
  }
}

export function* getUrlAlejandra({ productId }) {
  try {
    const MOCK_INFO = "getUrlAlejandra";
    const context = yield select(contextStore);
    const hiredProductsData = yield select(hiredProductsStore);
    let response = checkMocks(MOCK_INFO);
    const phoneNumber = getPhoneByHiredProductsAndProductId({
      hiredProductsData,
      productId,
    });
    const data = { phoneNumber };
    const urlAlejandra = yield select(urlAlejandraStore);
    if (!checkItemInArray({ items: urlAlejandra, phone: phoneNumber })) {
      if (response === null) {
        let getUrlAlejandraModule = yield call(() =>
          import("@/adabyron/telcol/servicios/router/gestion/sso")
        );
        let getUrlAlejandra = getUrlAlejandraModule.getUrlAlejandra;

        response = yield call(getUrlAlejandra, {
          data,
          context,
        });
      }
      const urlActivationAlejandra = response.datos.redirectUrl;
      const objToReduce = {
        urlActivationAlejandra,
        phoneNumber,
      };
      yield put(thirdActions.getUrlAlejandraSuccess(objToReduce));
    }
  } catch (error) {
    const reducerFailureAction = thirdActions.getUrlAlejandraFailure(true);
    yield handleSagaError(
      "getUrlAlejandra",
      error,
      "ERROR",
      0,
      reducerFailureAction
    );
  }
}

export function* getDevicesConnectedSmartWiFi({ phoneNumber, productId }) {
  try {
    const context = yield select(contextStore);
    const hiredProductsData = yield select(hiredProductsStore);
    const smartWifiDevice = yield select(smartWifiDevicesStore);
    let number = null;
    if (phoneNumber) {
      number = phoneNumber;
    } else {
      const phone = getPhoneByHiredProductsAndProductId({
        hiredProductsData,
        productId,
      });
      number = phone;
    }
    if (!checkSmartWifiDevice({ smartWifiDevice, phone: number })) {
      const data = { telefono: number };
      const smartWiFiStatus = yield call(getSmartWiFiStatus, {
        data,
        context,
      });
      if (smartWiFiStatus?.datos) {
        const { contratado: hired } = smartWiFiStatus.datos;
        if (hired) {
          let getDevicesConnectedSmartWiFiModule = yield call(() =>
            import(
              "@/adabyron/telcol/third-parties/get-devices-connected-smart-wifi"
            )
          );
          let getDevicesConnectedSmartWiFi =
            getDevicesConnectedSmartWiFiModule.getDevicesConnectedSmartWiFi;

          const response = yield call(getDevicesConnectedSmartWiFi, {
            data,
            context,
          });
          const { dispositivos = 0, devices = [] } = { ...response.datos };
          const devicesObj =
            normalizeGetDevicesConnectedSmartWiFiResponse(devices);
          yield put(
            thirdActions.successGetSmartWiFiDevices({
              phone: data.telefono,
              data: { dispositivos, devices: devicesObj },
            })
          );
        } else {
          yield put(
            thirdActions.failureGetSmartWiFiDevices({
              phone: data.telefono,
              type: "api",
            })
          );
        }
      } else {
        yield put(
          thirdActions.failureGetSmartWiFiDevices({
            phone: data.telefono,
            type: "api",
          })
        );
      }
    }
  } catch (error) {
    yield put(
      thirdActions.failureGetSmartWiFiDevices({
        type: "api",
      })
    );
  }
}

export function* getOthersDetailsSmartWiFi({ data }) {
  try {
    const context = yield select(contextStore);
    let getOthersDetailsSmartWiFiModule = yield call(() =>
      import(
        "@gcloud-npm/adabyron.servicios-terceros.smart-wifi.get-others-details"
      )
    );
    let getOthersDetailsSmartWiFi =
      getOthersDetailsSmartWiFiModule.getOthersDetailsSmartWiFi;
    const response = yield call(getOthersDetailsSmartWiFi, {
      data,
      context,
    });
    yield put(thirdActions.successGetSmartWiFiOthersDetails(response?.datos));
  } catch (error) {
    yield put(thirdActions.failureGetSmartWiFiOthersDetails(true));
  }
}

export function* managementSmartWiFi(data) {
  try {
    const { deviceData, line } = { ...data.payload };
    const context = yield select(contextStore);
    let managementSmartWiFiModule = yield call(() =>
      import("@gcloud-npm/adabyron.servicios-terceros.smart-wifi.management")
    );
    let managementSmartWiFi = managementSmartWiFiModule.managementSmartWiFi;

    const response = yield call(managementSmartWiFi, {
      data: deviceData,
      context,
    });
    yield put(thirdActions.successSmartWiFiManagement({ deviceData, line }));
  } catch (error) {
    const { deviceData, line } = { ...data.payload };
    yield put(
      thirdActions.failureSmartWiFiManagement({
        deviceData,
        line,
      })
    );
  }
}

export function* getGamePassActivationCodeData(args) {
  try {
    const { productId } = args;
    const data = { productId };
    const context = yield select(contextStore);
    const getGamePassCodeModule = yield call(() =>
      import(
        "@gcloud-npm/adabyron.client.servicios.misservicios.xboxgamepass.xboxgamepass"
      )
    );
    const getGamePassCodePromise = getGamePassCodeModule.getGamePassCode;
    const response = yield call(getGamePassCodePromise, {
      data,
      context,
    });
    const responseNormalizer = getGamePassActivationCodeDataResponseNormalizer(
      response,
      productId
    );
    yield put(
      thirdActions.setGamePassCode({
        data: responseNormalizer,
        fetching: false,
        error: false,
      })
    );
  } catch (error) {
    const { response } = error;
    const reducerFailureAction = yield put(
      thirdActions.setGamePassCode({
        data: null,
        fetching: false,
        error: true,
      })
    );
    yield handleSagaError(
      "getGamePassActivationCodeData",
      error,
      reducerFailureAction
    );
  }
}

export function* getPromotionalCode(args) {
  try {
    const context = yield select(contextStore);
    const data = { campaign: "PERPLEXITY" };
    const action = "order_tracking_client";

    const recaptchaId = process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID;
    const token = yield call(getToken, { action, recaptchaId });
    const module = yield call(() =>
      import("@gcloud-npm/adabyron.abs-layer.client.get-promotional-code")
    );
    const getPromotionalCode = module.getPromotionalCode;
    const response = yield call(getPromotionalCode, {
      data,
      context,
      token,
    });

    yield put(
      thirdActions.setPromoCodes({
        data: response,
        fetching: false,
        error: false,
      })
    );
  } catch (error) {
    const reducerFailureAction = yield put(
      thirdActions.setPromoCodes({
        data: null,
        fetching: false,
        error: true,
      })
    );
    yield handleSagaError("getPromotionalCode", error, reducerFailureAction);
  }
}
